import React, { ReactNode } from "react";
import { HelpPanel, Icon } from "@cloudscape-design/components";
import { v4 as uuidv4 } from "uuid";

import { MODE_WIKI_URL, TaCS_WIKI_URL, TutorialHotspot } from "./constants";

export const footer = (
  <div data-testid="tools-panel-info-tab-footer">
    <h3>
      <span></span>
      <span style={{ marginLeft: "5px" }}>
        <Icon name="external" />
      </span>
    </h3>
    <ul>
      <li>
        <a href={MODE_WIKI_URL} rel="noreferrer">
          Amazon MODE (Media, Operations, Data & Execution)
        </a>
      </li>
      <li>
        <a href={TaCS_WIKI_URL} rel="noreferrer">
          TaCS - (Taxonomy, Campaign, and Spend Tool)
        </a>
      </li>
    </ul>
  </div>
);

export const HelpPanelContent = () => {
  return new Map<TutorialHotspot, ReactNode>([
    [
      TutorialHotspot.manageCampaign,
      <div key={uuidv4()}>
        <HelpPanel
          header={
            <h2>
              Manage Campaigns
            </h2>
          }
          footer={footer}
        >
          <p>
            You can manage your campaign on this page. 
          </p>
        </HelpPanel>
      </div>
    ],
    [
      TutorialHotspot.createCampaignBtn,
      <div key={uuidv4()}>
        <HelpPanel
          header={
            <h2>
              Create new campaign
            </h2>
          }
        >
          <p>
            Create a new campaign. 
          </p>
        </HelpPanel>
      </div>
    ],
    [
      TutorialHotspot.filterCampaignItems,
      <div key={uuidv4()}>
        <HelpPanel
          header={
            <h2>
              Filter campaigns to view
            </h2>
          }
        >
          <p>
            You can enter text or properties to determine what campaigns should be displayed. 
          </p>
        </HelpPanel>
      </div>
    ],
    [
      TutorialHotspot.paginationAndDisplay,
      <div key={uuidv4()}>
        <HelpPanel
          header={
            <h2>
              Settings/Options
            </h2>
          }
        >
          <p>
            Choose how you want your campaigns to be displayed on the table.
          </p>
        </HelpPanel>
      </div>
    ],
    [
      TutorialHotspot.defaultContent,
      <div key={45}>
        <HelpPanel
          header={
            <h2>
              Learn more about TaCS
            </h2>
          }
        >
          <p>
            <a href={TaCS_WIKI_URL}>
              Visit our TaCS wiki</a>
            Visit our TaCS wiki to learn more about managing campaigns.
          </p>
        </HelpPanel>
      </div>
    ],
  ]);
};
